// src/pages/produtos/grupos/GrupoSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useGrupo } from '../../../contexts/produtos/GrupoContext';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalTable from '../../../components/modalForm/ModalTable';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import { normalizeText } from '../../../utils/stringUtils';
import LazyLoading from '../../../components/modalForm/LazyLoading';
import ModalSearchBar from '../../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';
import ModalSelectButton from '../../../components/modalForm/ModalSelectButton';

const GrupoSearch = ({ show, onHide, onSelectGrupo }) => {
    const { grupos } = useGrupo();
    const [filter, setFilter] = useState('');
    const [sortField, setSortField] = useState('id'); // 'id' ou 'descricao'
    const [sortDirection, setSortDirection] = useState('asc'); // 'asc' ou 'desc'

    const inputRef = useRef(null); // Referência para o input

    useEffect(() => {
        if (show) {
            setFilter('');
            if (inputRef.current) {
                inputRef.current.focus(); // Aplica o foco no input quando o modal abrir
            }
        }
    }, [show]);

    if (!show) return null;

    const normalizedFilter = normalizeText(filter);

    const filteredGrupos = grupos.filter(grupo =>
    normalizeText(grupo.descricao).includes(normalizedFilter)
    );

    // Cria uma cópia do array para evitar modificar o original e ordena
    const sortedGrupos = [...filteredGrupos].sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        } else if (sortField === 'descricao') {
            const descriptionA = a.descricao.toLowerCase();
            const descriptionB = b.descricao.toLowerCase();
            if (descriptionA < descriptionB) return sortDirection === 'asc' ? -1 : 1;
            if (descriptionA > descriptionB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }
        return 0; // Adicionado para evitar warnings
    });

    // Função para alternar a ordenação por campo
    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    // Função para lidar com o clique duplo na linha da tabela
    const handleDoubleClick = (grupo) => {
        onSelectGrupo(grupo);
        onHide();
    };

    return (
        <ModalContainer show={show} variant="busca" onHide={onHide}>
            <ModalHeader title="Buscar Grupo" onHide={onHide} />

            <ModalBody>
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por descrição..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading
                    items={sortedGrupos}
                    resetKey={`${filter}|${sortField}|${sortDirection}`}
                >
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable
                    containerRef={containerRef}
                    containerStyle={{ maxHeight: '55vh', overflowY: 'auto' }}
                    onContainerScroll={handleScroll}
                >
                    <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button 
                                    onClick={() => handleSort('id')} 
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }} 
                                    tabIndex={0}
                                 type="button">
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" scope="col" style={{ width: '60%' }} aria-sort={sortField === 'descricao' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button 
                                    onClick={() => handleSort('descricao')} 
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }} 
                                    tabIndex={0}
                                 type="button">
                                    Descrição
                                    {sortField === 'descricao' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '20%' }} >
                                Selecionar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map((grupo) => (
                            <tr 
                                key={grupo.id} 
                                onDoubleClick={() => handleDoubleClick(grupo)}                                        
                            >
                                <td className="text-end align-middle">{grupo.id}</td>
                                <td className="text-start align-middle">{grupo.descricao}</td>
                                <td className="text-center align-middle modal-select-column">
                                <ModalSelectButton
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => onSelectGrupo(grupo)}
                                    style={{ padding: '2px 6px' }}
                                 label={grupo.descricao} />
                                </td>
                            </tr>
                        ))}
                    </tbody>                        
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter>
                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>
        </ModalContainer>
    );
};

export default GrupoSearch;
